import { FormState } from './types';

export const INITIAL_VALUES: FormState = {
  firstName: '',
  email: '',
  lastName: '',
};
